<script>
import SchedulerLayout from '../../../Layouts/SchedulerLayout.vue';
import Services from './Services.vue';
import Appointment from './Appointment.vue';
import { useForm } from '@inertiajs/vue3';
import CustomerInfo from './CustomerInfo.vue';
import VehicleSelector from './VehicleSelector.vue';
import preferences from '../../Settings/Sections/Preferences.vue';
import ReviewConfirm from './ReviewConfirm.vue';
import Button from '../../../Components/Button.vue';
import TireConnect from './TireConnect.vue';
import { genericError } from '../../../Modules/Alerts.js';
import Confirmation from './Confirmation.vue';
import ShopSelector from './ShopSelector.vue';
import { route } from 'ziggy-js';
import Recommendatioms from '@/Pages/Scheduler/KioskScheduler/Recommendatioms.vue';
import moment from 'moment-timezone';
import Loading from '../../../Components/Loading.vue';
import Swal from 'sweetalert2';

export default {
  components: {
    Loading,
    Recommendatioms,
    ShopSelector,
    Confirmation,
    TireConnect,
    Button,
    ReviewConfirm,
    VehicleSelector,
    CustomerInfo,
    Appointment,
    Services,
  },

  inject: [],

  layout: SchedulerLayout,

  props: {
    shops: Array,
    shopID: Number,
    jobID: String,
    rwgtoken: String,
    autocompleteKey: String,
    tireConnect: Boolean,
    tireConnectData: Object,
    mapKey: String,
    colors: Object,
    steps: Object,
    shopSelector: Boolean,
    searchUpcoming: Boolean,
    redirectUrl: String,
    firstDayAvailable: String,
    msoMasterLogo: String,
    honeypot: Object,
    deferredServices: Object,
    customerID: Number,
    vehicleID: Number,
    micrositeContext: Boolean,
    canAddServicesFromReview: Boolean,
  },

  data() {
    return {
      navigating: false,
      allowVehicleAutoAdvance: !this.micrositeContext,
      preReadyHandler: null,
      recommendations: {},
      currentStep: 1,
      selectedShop: null,
      selectedShopKey: null,
      tireServiceShow: false,
      checked: false,
      checked_disclaimer: false,
      kioskMode: false,
      waiterAvailable: true,
      addedVehicles: [],
      stepperTitles: {
        services: 'Products and Services',
        appointments: 'Appointments',
        customer: 'Customer Lookup',
        vehicle: 'Select Vehicle to Service',
        recommendations: 'Prior Recommendations',
        review: 'Review and Confirm',
      },
      stepState: {
        step: 1,
        steps: this.steps,
      },
      shopState: {
        masterConfig: null,
        kioskKey: null,
      },
      stepperIcons: {
        services: 'fa fa-cog',
        appointments: 'fa fa-calendar',
        customer: 'fa fa-users',
        vehicle: 'fa-regular fa-square-check',
        recommendations: 'fa fa-lightbulb',
        review: 'fa-regular fa-circle-check',
      },
      ready: false,
      form: useForm({
        [this.honeypot.nameFieldName]: '',
        [this.honeypot.validFromFieldName]: this.honeypot.encryptedValidFrom,
        isKioskMode: this.searchUpcoming,
        services: [],
        appointment: null,
        customer: null,
        msoUserIds: [],
        msoSource: null,
        newCustomer: {
          firstname: null,
          lastname: null,
          email: null,
          phone: null,
          recievetext: false,
          recieveemail: false,
          send_followup: false,
          send_email_followup: false,
          text_marketing: false,
          email_marketing: false,
          text_marketing_optout: false,
          email_marketing_optout: false,
          opt_in_at: null,
          opt_in_decision: null,
          ph_id: null,
        },
        tireConnectData: null,
        preferences: {
          appointmentType: 'd',
          shuttleRide: false,
          textUpdate: false,
          emailUpdate: false,
        },
        googleReserveToken: null,
        questionaire: {},
        signature: null,
        vehicle: null,
        recommendations: {},
        inspec_images: {},
        inspec_videos: {},
        deferred_services: [],
        newVehicle: {
          year: null,
          model: null,
          license: null,
          make: null,
          mileage: null,
          license_state: null,
        },
        deferred_services: [],
      }),
      initialAvailableDates: null,
      submitting: false,
      errors: {},
      submitted: false,
      settings: null,
      effectiveFirstDayAvailable: null,
      effectiveFirstDayAvailableLoading: false,
      effectiveFirstDayRequest: null,
      externalTireConnect: false,
      /** Set when the user enters TireConnect from the review step's Shop for Tires CTA. */
      shopForTiresFromReview: false,
      /** Set when the user returns to the services step from the review step's Add Services CTA. */
      addServicesFromReview: false,
      /** True while we re-check the held slot against the current service list. */
      revalidatingAppointment: false,
      /** Last GTM container ID we injected (avoids duplicate gtm.js; unlike `window.dataLayer`, which is initialized by analytics events before GTM loads). */
      gtmContainerIdLoaded: null,
    };
  },

  computed: {
    preferences() {
      return preferences;
    },

    selectedTitle() {
      if (this.selectedShop == null) {
        return 'Select Shop';
      }
      let step = this.steps[this.currentStep];
      return this.stepperTitles[step] || 'Missing Title';
    },

    selectedIcon() {
      if (this.selectedShop == null) {
        return 'fa-solid fa-shop';
      }
      let step = this.steps[this.currentStep];
      return this.stepperIcons[step] || 'Missing Icon';
    },

    hasTireServiceSelected() {
      // If TC data is already loaded (from URL param or postMessage), skip the widget step
      if (this.form.tireConnectData) {
        return false;
      }

      if (Object.keys(this.form.services.length) === 0) {
        return false;
      }

      if (!this.tireConnectEnabled) {
        return false;
      }

      let filteredTireConnect = this.form.services.filter((service) => {
        return service.tire_connect_service;
      });

      return filteredTireConnect.length > 0;
    },

    tireConnectEnabled() {
      // this.settings is refetched for the shop selected via ShopSelector (see getSettings()),
      // while this.tireConnect is a page-load prop scoped to the primary/entry shop. Prefer the
      // refreshed value once available; fall back to the prop only before the first getSettings()
      // response arrives.
      return this.settings?.tire_connect_enabled ?? this.tireConnect;
    },

    hasDeferredServices() {
      return (
        this.deferredServices &&
        Array.isArray(this.deferredServices) &&
        this.deferredServices.length > 0
      );
    },

    showShopForTiresButton() {
      return (
        this.submitted === false &&
        this.currentStep === Object.keys(this.steps).length &&
        Object.values(this.steps).includes('appointments') &&
        !!this.settings?.slot_settings?.shop_for_tires &&
        this.tireConnectEnabled === true &&
        !this.form.tireConnectData
      );
    },

    showAddServicesButton() {
      return (
        this.submitted === false &&
        this.currentStep === Object.keys(this.steps).length &&
        Object.values(this.steps).includes('appointments') &&
        this.canAddServicesFromReview === true
      );
    },

    // The widget seeds `__`-prefixed placeholder payloads that the availability
    // endpoint's validator rejects. Mirrors the guard in Appointment.vue.
    validTireConnectData() {
      const data = this.form.tireConnectData;
      if (!data || typeof data !== 'object') return null;
      if (typeof data.key === 'string' && data.key.startsWith('__')) return null;
      return data;
    },
  },

  created() {
    this.setupShop();
    if (this.rwgtoken !== undefined && this.rwgtoken !== null) {
      this.form.googleReserveToken = this.rwgtoken;
    }
    this.setupDeferredServices();
    this.setupColors();
    const script = document.createElement('script');
    script.src = 'https://app.tireconnect.ca/js/widget.js';
    script.async = true;
    document.body.appendChild(script);

    // Initialize effective first day available
    if (this.tireConnectData) {
      this.form.tireConnectData = this.tireConnectData;
    }

    if (this.firstDayAvailable) {
      this.effectiveFirstDayAvailable = this.firstDayAvailable;
    }
  },

  mounted() {
    window.addEventListener('message', this.handleTireConnectMessage);
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    // TireConnect widget events are handled by TireConnect.vue via TCWidget.on() callbacks
    // which properly check event.status === 'submitted' before advancing the flow
  },

  beforeUnmount() {
    window.removeEventListener('message', this.handleTireConnectMessage);
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },

  methods: {
    handleNextClick() {
      if (this.preReadyHandler) {
        this.preReadyHandler();
        return;
      }
      this.nextStep();
    },

    route,
    shouldListenForExternalTireConnect() {
      const selectedMsoId = Number(this.selectedShop?.mso_id ?? 0);
      const isDev = import.meta?.env?.DEV === true || import.meta?.env?.MODE === 'development';

      return selectedMsoId === 146 || isDev || this.tireConnectEnabled === true;
    },

    handleTireConnectMessage(event) {
      if (!this.shouldListenForExternalTireConnect()) {
        return;
      }

      if (event?.origin === 'https://js.stripe.com') {
        return;
      }

      let data = event.data;

      // Handle cases where the payload is sent as a JSON string
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {
          // Not valid JSON string, ignore
          return;
        }
      }

      if (!data || typeof data !== 'object') {
        return;
      }

      const isTireConnectPayload =
        data.vehicle !== undefined ||
        data.customer !== undefined ||
        data.tires !== undefined ||
        data.services !== undefined ||
        data.quote !== undefined;

      if (!isTireConnectPayload) {
        return;
      }

      // Assign the valid payload to our form data
      this.form.tireConnectData = data;
      this.externalTireConnect = true;
    },

    setupDeferredServices() {
      if (!this.hasDeferredServices) {
        return;
      }

      this.form.deferred_services = this.deferredServices.map((service) => service.history_job_id);

      this.form.services.push({
        kiosk_job_id: 'DEC',
        icon: null,
        job_description: '--',
        job_name: 'Previously Declined Services',
        selected: true,
      });

      this.checked = true;
    },

    iconSelected(index) {
      // Direct lookup from steps mapping to icons
      let stepKey = Object.keys(this.steps)[index];
      let step = this.steps[stepKey];
      return this.stepperIcons[step] || 'fa-solid fa-circle-question';
    },

    getRecommendations() {
      if (this.form.customer == null || this.form.vehicle == null) {
        return;
      }

      axios
        .post(
          route('scheduler.recommendations', {
            key: this.selectedShopKey,
          }),
          {
            customer_id: this.form.customer,
            vehicle_id: this.form.vehicle,
          },
        )
        .then((response) => {
          this.recommendations = response.data.data.recommendations;
          this.inspec_images = response.data.data?.images;
          this.inspec_videos = response.data.data?.videos;
        });
    },

    setupColors() {
      let colors = this.colors;
      if (this.selectedShop !== null) {
        colors = this.selectedShop.colors;
      }

      if (colors.primaryColor !== null && colors.primaryColor !== undefined) {
        document.documentElement.style.setProperty(
          '--autoflow-scheduler-primary-color',
          colors.primaryColor,
        );
      }

      if (colors.secondaryColor !== null && colors.secondaryColor !== undefined) {
        document.documentElement.style.setProperty(
          '--autoflow-scheduler-secondary-color',
          colors.secondaryColor,
        );
      }

      if (colors.textColor !== null && colors.textColor !== undefined && colors.textColor !== '') {
        document.documentElement.style.setProperty('--bs-heading-color', colors.textColor);
        document.documentElement.style.setProperty('--ink-primary-color', colors.textColor);
        document.documentElement.style.setProperty('--bs-body-color', colors.textColor);
      }
    },

    checkin(status) {
      this.submitting = true;

      axios
        .post(
          route('scheduler.checkin', {
            key: this.selectedShopKey,
          }),
          {
            status_id: status.status_id,
          },
        )
        .then((response) => {
          this.kioskMode = true;
          this.submitted = true;
          if (this.redirectUrl) {
            setTimeout(() => {
              window.location.href = this.redirectUrl;
            }, 500);
          }
        })
        .catch((error) => {
          notyf.error({
            message:
              'There was an error getting your checked in. Please talk to our staff in shop.',
            dismissible: false,
            duration: 30000,
          });
        })
        .finally(() => [(this.submitting = false)]);
    },

    submit() {
      if (this.submitting) return; // guard against double-click
      this.submitting = true;

      axios
        .post(route('scheduler.submit', { key: this.selectedShopKey }), this.form.data())
        .then((response) => {
          this.submitted = true;
          this.pushAnalyticsEvent('scheduler_complete');
          if (this.redirectUrl) {
            setTimeout(() => {
              window.location.href = this.redirectUrl;
            }, 500);
          }
        })
        .catch((error) => {
          const payload = error?.response?.data;
          const appError = payload?.data?.error;
          const tab = payload?.data?.tab;
          const validationErrors = payload?.errors;
          const validationMessage = validationErrors
            ? Object.values(validationErrors).flat().find((msg) => !!msg)
            : null;
          const message =
            appError ??
            validationMessage ??
            payload?.message ??
            'There was a problem booking your appointment. Please contact the shop.';

          if (appError !== undefined && appError !== null) {
            this.errors = appError;
            if (tab) {
              // Navigate back when the error is related to appointment selection
              // (e.g. slot no longer available).
              this.goToStep(tab);
            }
          } else if (validationErrors) {
            this.errors = validationErrors;
          }

          notyf.error({
            message,
            duration: 5000,
          });
        })
        .finally(() => {
          this.submitting = false; // always reset so user can retry on error
        });
    },

    updateForm(key, value) {
      this.form[key] = value;
    },

    /**
     * Push an analytics event to GTM/GA4 (window.dataLayer) and HubSpot (window._hsq).
     * The mso_shop_id from the selected shop's master_config record is included in every event.
     *
     * GTM/GA4: reads window.dataLayer natively — no extra configuration required.
     * HubSpot: window._hsq.push() is a safe no-op when HubSpot is not yet installed;
     *          once they go live with HubSpot it will fire automatically.
     */
    pushAnalyticsEvent(eventName) {
      const msoShopId = this.selectedShop?.mso_shop_id ?? null;

      // Google Tag Manager / GA4
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        mso_shop_id: msoShopId,
      });

      // HubSpot (safe no-op until their tracking script is present)
      window._hsq = window._hsq || [];
      window._hsq.push(['trackEvent', { id: eventName, value: msoShopId }]);
    },

    handleBeforeUnload() {
      this.pushAnalyticsEvent('scheduler_close');
    },

    setupShop() {
      let shop = null;
      if (this.shops.length === 1) {
        shop = this.shops[0];
      } else if (this.shopSelector === false) {
        shop = this.shops.find((item) => {
          return item.shop_id == this.shopID;
        });
      }
      if (shop) {
        this.setShop(shop);
      } else {
        console.warn('Multiple Shops. Select Shop First');
      }
    },

    updateTracking() {
      axios
        .post(
          route('scheduler.tracker', {
            key: this.selectedShopKey,
          }),
          {
            step: this.currentStep,
          },
        )
        .then((response) => {});
    },

    setShop(shop) {
      this.selectedShop = shop;
      this.selectedShopKey = shop.kiosk_key;

      this.shopState.masterConfig = shop;
      this.shopState.kioskKey = shop.kiosk_key;
      this.stepState.step = this.currentStep;
      this.stepState.steps = this.steps;
      this.getSettings();
      this.setupColors();
    },

    loadGoogleTagManager() {
      const rawKey = this.settings?.slot_settings?.google_tag_key;
      const gtmKey = typeof rawKey === 'string' ? rawKey.trim() : '';

      if (!gtmKey) {
        return;
      }

      // Match version3 kioskv2: inject gtm.js when a key is set. Do not use `window.dataLayer` as
      // a guard — pushAnalyticsEvent() initializes dataLayer before this runs asynchronously.
      if (this.gtmContainerIdLoaded === gtmKey) {
        return;
      }

      const alreadyInDom = document.querySelector(
        `script[src^="https://www.googletagmanager.com/gtm.js?id=${gtmKey}"]`,
      );
      if (alreadyInDom) {
        this.gtmContainerIdLoaded = gtmKey;
        return;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      });

      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmKey}`;

      const firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode.insertBefore(script, firstScript);
      this.gtmContainerIdLoaded = gtmKey;
    },

    getSettings() {
      axios
        .post(
          route('scheduler.settings', {
            key: this.selectedShopKey,
          }),
        )
        .then((response) => {
          this.settings = response.data.data;
          this.updateEffectiveFirstDayAvailable();
          this.loadGoogleTagManager();
          this.pushAnalyticsEvent('scheduler_view');
        });
    },

    updateEffectiveFirstDayAvailable() {
      if (!this.selectedShopKey) return;

      this.effectiveFirstDayAvailableLoading = true;
      this.effectiveFirstDayAvailable = null;

      // Always fetch from the API so we get the effective first day for the *selected*
      // shop. The `firstDayAvailable` prop is computed server-side for the page-load
      // shop (the MSO master), so using it directly for a child shop selected via
      // ShopSelector would open the calendar on the wrong month.
      const payload = this.form.tireConnectData
        ? { tireConnectData: this.form.tireConnectData, includeAvailableDates: true }
        : {};

      this.initialAvailableDates = null;

      this.effectiveFirstDayRequest = axios
        .post(route('scheduler.effective-first-day', { key: this.selectedShopKey }), payload)
        .then((response) => {
          this.effectiveFirstDayAvailable = response.data.data.date;
          this.initialAvailableDates = response.data.data.available_dates ?? null;
        })
        .catch(() => {
          this.effectiveFirstDayAvailable = this.firstDayAvailable;
          this.initialAvailableDates = null;
        })
        .finally(() => {
          this.effectiveFirstDayAvailableLoading = false;
        });

      return this.effectiveFirstDayRequest;
    },

    updateQuestion(question) {
      if (question.question !== undefined) {
        let index = question.question.q_id;
        this.form.questionaire[index] = question.question;
      }

      if (question.service !== undefined) {
        let index = this.form.services.findIndex(
          (service) => service.kiosk_job_id === question.service.kiosk_job_id,
        );
        if (index > -1) {
          this.form.services[index] = question.service;
        }
      }

      if (question.signature !== undefined) {
        this.form.signature = question.signature;
      }
    },

    nextStep() {
      if (this.navigating) return;
      this.navigating = true;

      try {
        this.allowVehicleAutoAdvance = !this.micrositeContext;

        if (this.currentStep < Object.keys(this.steps).length) {
          if (
            this.shopForTiresFromReview &&
            this.currentStep === 1 &&
            this.tireServiceShow === true &&
            this.form.tireConnectData
          ) {
            this.returnFromShopForTires();
            return;
          }

          if (this.addServicesFromReview && this.steps[this.currentStep] === 'services') {
            // A TireConnect service was added: hand off to the tire widget and let the
            // Shop for Tires return path, which also awaits delivery, finish the trip.
            if (this.hasTireServiceSelected && this.tireServiceShow === false) {
              this.addServicesFromReview = false;
              this.shopForTiresFromReview = true;
              this.tireServiceShow = true;
              this.ready = false;
              return;
            }

            this.returnToReviewIfTimeStillValid();
            return;
          }

          // Customer, vehicle, and recommendations were already completed before the
          // review-step CTA, so return to review once a new time is picked.
          if (
            (this.shopForTiresFromReview || this.addServicesFromReview) &&
            this.steps[this.currentStep] === 'appointments'
          ) {
            this.shopForTiresFromReview = false;
            this.addServicesFromReview = false;
            this.currentStep = this.stepIndex('review');
            this.ready = false;
            this.updateTracking();
            return;
          }

          if (
            this.hasTireServiceSelected &&
            this.currentStep === 1 &&
            this.tireServiceShow === false
          ) {
            this.tireServiceShow = true;
            this.ready = false;
            return;
          }

          // Fire scheduler_start when the user advances beyond the services step
          if (this.currentStep === 1) {
            this.pushAnalyticsEvent('scheduler_start');
          }

          this.tireServiceShow = false;
          this.currentStep++;
          this.ready = false;

          if (
            Object.keys(this.recommendations).length === 0 &&
            this.steps[this.currentStep] == 'recommendations'
          ) {
            this.currentStep++;
          }

          this.updateTracking(this.currentStep);
        }
      } finally {
        this.$nextTick(() => {
          this.navigating = false;
        });
      }
    },

    updateServices(value) {
      const prevCount = this.form.services.length;

      if (value.services !== undefined) {
        this.form.services = value.services;

        // Fire scheduler_select when a service is added (count increases)
        if (this.form.services.length > prevCount) {
          this.pushAnalyticsEvent('scheduler_select');
        }
      }

      if (value.checked !== undefined) {
        this.checked = value.checked;
      }
    },

    updateCustomerInfo(value) {
      Object.keys(value).forEach((key) => {
        this.form[key] = value[key];
      });
    },

    updateVehicleInfo(value) {
      if (value.newVehicle !== undefined) {
        const newVehicle = value.newVehicle;
        const isDraftVehicle = newVehicle && newVehicle.vehicle_id === undefined;

        if (isDraftVehicle) {
          const existingIndex = this.addedVehicles.findIndex((vehicle) => {
            return (
              String(vehicle.year ?? '')
                .trim()
                .toLowerCase() ===
                String(newVehicle.year ?? '')
                  .trim()
                  .toLowerCase() &&
              String(vehicle.make ?? '')
                .trim()
                .toLowerCase() ===
                String(newVehicle.make ?? '')
                  .trim()
                  .toLowerCase() &&
              String(vehicle.model ?? '')
                .trim()
                .toLowerCase() ===
                String(newVehicle.model ?? '')
                  .trim()
                  .toLowerCase() &&
              String(vehicle.license ?? '')
                .trim()
                .toLowerCase() ===
                String(newVehicle.license ?? '')
                  .trim()
                  .toLowerCase() &&
              String(vehicle.license_state ?? '')
                .trim()
                .toLowerCase() ===
                String(newVehicle.license_state ?? '')
                  .trim()
                  .toLowerCase()
            );
          });

          if (existingIndex === -1) {
            this.addedVehicles = [newVehicle, ...this.addedVehicles];
          } else {
            this.addedVehicles.splice(existingIndex, 1, newVehicle);
          }
        }
      }

      Object.keys(value).forEach((key) => {
        this.form[key] = value[key];
      });
    },

    prevStep() {
      if (this.navigating) return;
      this.navigating = true;

      try {
        this.allowVehicleAutoAdvance = false;

        if (this.tireServiceShow === true && this.shopForTiresFromReview) {
          this.shopForTiresFromReview = false;
          this.tireServiceShow = false;
          this.currentStep = this.stepIndex('review');
          this.ready = false;
          this.updateTracking();
          return;
        }

        // Services may already have changed, so Back re-validates rather than
        // returning to review with a time that no longer fits.
        if (this.addServicesFromReview && this.steps[this.currentStep] === 'services') {
          this.returnToReviewIfTimeStillValid();
          return;
        }

        if (this.tireServiceShow === true) {
          this.tireServiceShow = false;
          return;
        }

        if (
          Object.keys(this.recommendations).length === 0 &&
          this.steps[this.currentStep] == 'review'
        ) {
          this.currentStep--;
        }

        if (this.currentStep > 0) {
          this.currentStep--;
          this.ready = false;
        }
      } finally {
        this.$nextTick(() => {
          this.navigating = false;
        });
      }
    },

    goToStep(stepNumber) {
      const targetStep = Number(stepNumber);
      if (Number.isNaN(targetStep)) {
        return;
      }

      // Allow navigating back to previous/current steps only.
      if (targetStep > this.currentStep) {
        return;
      }

      this.tireServiceShow = false;
      this.shopForTiresFromReview = false;
      this.addServicesFromReview = false;
      this.allowVehicleAutoAdvance = false;
      this.currentStep = targetStep;
      this.ready = false;
      this.updateTracking();
    },

    confirmTimeMayChange(text) {
      return Swal.fire({
        text,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Proceed',
        cancelButtonText: 'Cancel',
        customClass: {
          confirmButton: 'btn btn-success btn-lg',
          cancelButton: 'btn btn-secondary btn-lg',
        },
      }).then((result) => result.isConfirmed);
    },

    handleShopForTiresClick() {
      this.confirmTimeMayChange(
        "Your appointment time may change depending on when your tires can be delivered. If your current time is no longer available, you'll be asked to choose a new one.",
      ).then((confirmed) => {
        if (confirmed) {
          this.proceedShopForTires();
        }
      });
    },

    handleAddServicesClick() {
      this.confirmTimeMayChange(
        "Adding services may change how long your appointment takes. If your current time is no longer available, you'll be asked to choose a new one.",
      ).then((confirmed) => {
        if (confirmed) {
          this.proceedAddServices();
        }
      });
    },

    proceedAddServices() {
      if (this.navigating) return;
      this.navigating = true;

      try {
        // The appointment is deliberately kept: it is re-checked against the new
        // service list on the way back, and only dropped if it no longer fits.
        this.addServicesFromReview = true;
        this.allowVehicleAutoAdvance = false;
        this.tireServiceShow = false;
        this.currentStep = this.stepIndex('services');
        this.ready = false;
        this.updateTracking();
      } finally {
        this.$nextTick(() => {
          this.navigating = false;
        });
      }
    },

    async ensureTireConnectServiceSelected() {
      const alreadySelected = this.form.services.some(
        (service) => service.tire_connect_service,
      );
      if (alreadySelected) {
        return;
      }

      try {
        const response = await axios.post(
          route('scheduler.services', { key: this.selectedShopKey }),
        );
        const services = response.data?.data?.services || [];
        const tireService = services.find((service) => service.tire_connect_service);
        if (tireService) {
          this.form.services = [...this.form.services, tireService];
        }
      } catch (error) {
        console.log(error);
        genericError();
      }
    },

    async proceedShopForTires() {
      if (this.navigating) return;
      this.navigating = true;

      try {
        await this.ensureTireConnectServiceSelected();

        this.shopForTiresFromReview = true;
        this.allowVehicleAutoAdvance = false;
        this.currentStep = 1;
        this.tireServiceShow = true;
        this.ready = false;
        this.updateTracking();
      } finally {
        this.$nextTick(() => {
          this.navigating = false;
        });
      }
    },

    stepIndex(stepName) {
      return Number(Object.keys(this.steps).find((key) => this.steps[key] === stepName));
    },

    /**
     * Re-check the held slot against the *current* service list. The availability
     * endpoint sizes each slot by the services it is given, so a slot that no longer
     * fits the longer appointment simply stops being returned. Passing tireConnectData
     * also applies the tire-delivery bound, and the shop's own earliest-appointment
     * bound is always applied server-side, in the shop's timezone.
     */
    async isAppointmentSlotStillAvailable() {
      if (!this.form.appointment) return false;

      const slot = moment.parseZone(this.form.appointment);

      try {
        const response = await axios.post(
          route('scheduler.availability', { key: this.selectedShopKey }),
          {
            date: slot.format('YYYY-MM-DD'),
            services: this.form.services.map((service) => service.kiosk_job_id),
            tireConnectData: this.validTireConnectData,
          },
        );

        const slots = response.data?.data?.slots ?? {};

        return Object.keys(slots).some((key) => moment.parseZone(key).isSame(slot));
      } catch (error) {
        // Fail safe: ask for a new time rather than hold a slot we could not confirm.
        return false;
      }
    },

    async returnToReviewIfTimeStillValid() {
      this.revalidatingAppointment = true;
      this.ready = false;

      try {
        if (await this.isAppointmentSlotStillAvailable()) {
          this.shopForTiresFromReview = false;
          this.addServicesFromReview = false;
          this.currentStep = this.stepIndex('review');
        } else {
          // Keep the flag so the appointments step returns straight to review instead
          // of walking forward through customer/vehicle/recommendations again.
          this.form.appointment = null;
          this.currentStep = this.stepIndex('appointments');
        }

        this.updateTracking();
      } finally {
        this.revalidatingAppointment = false;
      }
    },

    async returnFromShopForTires() {
      // Wait for the tire-aware effective first day triggered by the tireConnectData watcher.
      await (this.effectiveFirstDayRequest ?? this.updateEffectiveFirstDayAvailable());

      if (!this.shopForTiresFromReview || !this.tireServiceShow) return;

      this.tireServiceShow = false;

      await this.returnToReviewIfTimeStillValid();
    },
  },

  watch: {
    currentStep() {
      this.preReadyHandler = null;
    },

    'form.customer'(newValue, oldValue) {
      if (newValue !== null) {
        this.getRecommendations();
        return;
      }
      this.recommendations = {};
      this.inspec_images = {};
      this.inspec_videos = {};
    },

    'form.vehicle'(newValue, oldValue) {
      if (newValue !== null) {
        this.getRecommendations();
        return;
      }
      this.recommendations = {};
      this.inspec_images = {};
      this.inspec_videos = {};
    },

    'form.tireConnectData'() {
      this.updateEffectiveFirstDayAvailable();

      // The vehicle was already confirmed before Shop for Tires, and that screen is skipped.
      if (this.shopForTiresFromReview) return;

      // Pre-fill vehicle info from TireConnect data.
      // Flat format (widget onOrderSubmitted): vehicle is at the top level.
      // Quote-wrapped format (MSO-146 / URL-param): vehicle is under customer.vehicle.
      const vehicle =
        this.form.tireConnectData?.vehicle ?? this.form.tireConnectData?.customer?.vehicle;
      if (vehicle) {
        if (vehicle.year) this.form.newVehicle.year = String(vehicle.year);
        if (vehicle.make) this.form.newVehicle.make = vehicle.make;
        if (vehicle.model) this.form.newVehicle.model = vehicle.model;
      }
    },
  },
};
</script>

<template>
  <div id="scheduler__container">
    <nav class="navbar navbar-light bg-light border-bottom fixed-top secondary-color">
      <div class="container">
        <h6 class="m-0 font-heavy">
          <i class="primary-color" :class="selectedIcon" /> {{ selectedTitle }}
        </h6>
        <h6 v-if="selectedShop !== null" class="m-0 text-end d-none d-sm-flex font-heavy">
          {{ selectedShop.public_name || selectedShop.shop_name }} - {{ selectedShop.address }}
        </h6>
      </div>
    </nav>

    <div class="container py-5" id="main-schedule-content">
      <span
        v-for="(step, index) in Object.keys(steps)"
        :key="index"
        class="step-dot"
        :class="{ active: index + 1 === currentStep }"
      />

      <div class="stepper ms-2 me-2 d-flex justify-content-center align-items-center mb-4">
        <template v-for="(step, index) in Object.keys(steps)">
          <div
            class="step"
            :class="{
              active: currentStep == step,
              clickable: index + 1 <= currentStep,
            }"
            role="button"
            :tabindex="index + 1 <= currentStep ? 0 : -1"
            @click="goToStep(step)"
            @keydown.enter.prevent="goToStep(step)"
            @keydown.space.prevent="goToStep(step)"
          >
            <div class="circle primary-color">
              <i class="primary-color" :class="iconSelected(index)" />
            </div>
          </div>
          <div
            v-if="index + 1 < Object.keys(steps).length"
            class="line secondary-color-background"
          ></div>
        </template>
      </div>

      <template v-if="selectedShop === null && shopSelector === true">
        <ShopSelector
          :api-key="mapKey"
          :shops="shops"
          @selected="(newValue) => setShop(newValue)"
        />
      </template>

      <template v-else>
        <Services
          v-if="
            steps[currentStep] == 'services' && tireServiceShow === false && submitted === false
          "
          @pre-ready="(handler) => (preReadyHandler = handler)"
          :master-config="selectedShop"
          :kiosk-key="selectedShopKey"
          :selected="form.services"
          :job-i-d="jobID"
          :settings="settings"
          :agreed="checked"
          :deferred-services="deferredServices"
          :tire-connect-data="form.tireConnectData"
          @ready="(newvalue) => (ready = newvalue)"
          @update="(newValue) => updateServices(newValue)"
          @next="nextStep"
        />

        <TireConnect
          v-if="steps[currentStep] == 'services' && tireServiceShow === true && submitted === false"
          :master-config="selectedShop"
          :kiosk-key="selectedShopKey"
          @ready="(newValue) => (ready = newValue)"
          @update="(newValue) => (form.tireConnectData = newValue.tireConnectData)"
          @next="nextStep"
        />

        <Appointment
          v-if="
            steps[currentStep] == 'appointments' &&
            submitted === false &&
            !effectiveFirstDayAvailableLoading &&
            effectiveFirstDayAvailable
          "
          :master-config="selectedShop"
          :initial-available-dates="initialAvailableDates"
          :kiosk-key="selectedShopKey"
          :selected="form.appointment"
          :services="form.services"
          :firstDayAvailable="effectiveFirstDayAvailable"
          :tire-connect-data="form.tireConnectData"
          @update="(newValue) => updateForm('appointment', newValue)"
          @waiter="(newValue) => (waiterAvailable = newValue)"
          @ready="(newValue) => (ready = newValue)"
          @preference="(newValue) => (form.preferences.appointmentType = newValue)"
        />

        <Loading
          v-else-if="steps[currentStep] == 'appointments' && submitted === false"
          class="mt-3"
        />

        <CustomerInfo
          v-if="steps[currentStep] == 'customer' && submitted === false"
          :master-config="selectedShop"
          :kiosk-key="selectedShopKey"
          :customer="form.customer"
          :customerID="customerID"
          :new-customer="form.newCustomer"
          :new-preferences="form.preferences"
          :search-upcoming="searchUpcoming"
          :autocomplete-key="autocompleteKey"
          :waiter-available="waiterAvailable"
          :tire-connect-customer="form.tireConnectData?.customer ?? null"
          @ready="(newvalue) => (ready = newvalue)"
          @update="(newValue) => updateCustomerInfo(newValue)"
          @checkin="(newValue) => checkin(newValue)"
        />

        <VehicleSelector
          v-if="steps[currentStep] == 'vehicle' && submitted === false"
          :allow-auto-advance="allowVehicleAutoAdvance"
          :master-config="selectedShop"
          :kiosk-key="selectedShopKey"
          :new-vehicle="form.newVehicle"
          :persisted-vehicles="addedVehicles"
          :selected-vehicle-id="form.vehicle"
          :customer="form.customer"
          :mso-user-ids="form.msoUserIds"
          :new-customer="form.newCustomer"
          :vehicleID="vehicleID"
          @ready="(newValue) => (ready = newValue)"
          @update="(newValue) => updateVehicleInfo(newValue)"
          @next="nextStep"
        />

        <Recommendatioms
          v-if="steps[currentStep] == 'recommendations' && submitted === false"
          :master-config="selectedShop"
          :kiosk-key="selectedShopKey"
          :recommendations="recommendations"
          :inspec_images="inspec_images"
          :inspec_videos="inspec_videos"
          :customer-recommendations="form.recommendations"
          @recommendation="(newValue) => (form.recommendations = newValue)"
          @ready="(newValue) => (ready = newValue)"
        />

        <ReviewConfirm
          v-if="steps[currentStep] == 'review' && submitted === false"
          :master-config="selectedShop"
          :kiosk-key="selectedShopKey"
          :form="form"
          :agreed="checked_disclaimer"
          :deferred-services="deferredServices"
          @pre-ready="(handler) => (preReadyHandler = handler)"
          @ready="(newValue) => (ready = newValue)"
          @update="updateQuestion"
        />

        <Confirmation
          v-if="submitted === true"
          :master-config="selectedShop"
          :kiosk-key="selectedShopKey"
          :form="form"
          :kiosk="kioskMode"
        />
      </template>

      <div v-if="honeypot.enabled" :name="`${honeypot.nameFieldName}_wrap`" style="display: none">
        <input
          type="text"
          v-model="form[honeypot.nameFieldName]"
          :name="honeypot.nameFieldName"
          :id="honeypot.nameFieldName"
        />
        <input
          type="text"
          v-model="form[honeypot.validFromFieldName]"
          :name="honeypot.validFromFieldName"
        />
      </div>
    </div>

    <footer class="border-top bg-white py-3 fixed-bottom secondary-color">
      <div class="container d-flex mt-2 justify-content-between align-items-center flex-wrap">
        <div id="powered-by" class="text-muted small d-flex align-items-center">
          <div class="text-center">
            <template v-if="selectedShop !== null && selectedShop?.logo !== null">
              <img :src="selectedShop.logo" style="height: 40px" />
            </template>

            <template v-else-if="msoMasterLogo != null">
              <img :src="msoMasterLogo" style="height: 40px" />
            </template>

            <template v-else>
              Powered by <br />
              <img
                src="https://atme-cdn.s3.us-west-2.amazonaws.com/assets/autoflow-logo.png"
                alt="Autoflow Logo"
                style="height: 40px"
              />
            </template>
          </div>
        </div>

        <div class="d-flex ml-auto">
          <template v-if="submitted === true">
            <a
              v-if="kioskMode === true"
              :href="route('kiosk.index', { key: selectedShopKey })"
              class="btn btn-light mr-2"
            >
              Schedule Another Appointment
            </a>
            <a
              v-else-if="shopSelector === true"
              :href="route('scheduler.index', { key: selectedShopKey })"
              class="btn btn-light mr-2"
            >
              Schedule Another Appointment
            </a>

            <a
              v-else
              :href="route('scheduler.index', { key: selectedShopKey, shop_only: 1 })"
              class="btn btn-light mr-2"
            >
              Schedule Another Appointment
            </a>
          </template>
          <template v-else>
            <span v-if="revalidatingAppointment" class="d-flex align-items-center mr-2">
              <Loading />
            </span>

            <button
              class="btn btn-light mr-2"
              :disabled="
                (currentStep === 1 && tireServiceShow === false && !addServicesFromReview) ||
                navigating ||
                revalidatingAppointment
              "
              @click="prevStep"
            >
              &laquo; Back
            </button>

            <button
              v-if="currentStep !== Object.keys(steps).length"
              class="btn btn-primary ms-2"
              :class="{
                'primary-color-background': !ready && !preReadyHandler,
                'btn-warning': preReadyHandler && !ready,
              }"
              :disabled="(!ready && !preReadyHandler) || navigating || revalidatingAppointment"
              @click="handleNextClick"
            >
              Next &raquo;
            </button>

            <template v-else>
              <button
                v-if="showAddServicesButton"
                class="btn btn-light ms-2"
                :disabled="navigating || revalidatingAppointment"
                @click="handleAddServicesClick"
              >
                Add Services
              </button>

              <button
                v-if="showShopForTiresButton"
                class="btn btn-light ms-2"
                :disabled="navigating || revalidatingAppointment"
                @click="handleShopForTiresClick"
              >
                Shop for Tires
              </button>

              <button
                class="btn btn-primary ms-2"
                :class="{
                  'btn-warning': preReadyHandler && !ready,
                }"
                :disabled="(!ready && !preReadyHandler) || submitting === true || navigating"
                @click="preReadyHandler && !ready ? preReadyHandler() : submit()"
              >
                {{
                  Object.values(steps).includes('appointments')
                    ? 'Book Appointment'
                    : 'Complete Check-in'
                }}
              </button>
            </template>
          </template>
        </div>
      </div>
    </footer>
  </div>
</template>

<style>
.fixed-top {
  top: 0;
  width: 100%;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 1030;
}

.secondary-color {
  color: var(--autoflow-scheduler-secondary-color);
}

.secondary-color-background {
  background-color: var(--autoflow-scheduler-secondary-color) !important;
}

i.primary-color {
  color: var(--autoflow-scheduler-primary-color);
}

h6.primary-color {
  color: var(--autoflow-scheduler-primary-color);
}

.primary-color-background {
  background-color: var(--autoflow-scheduler-primary-color) !important;
  border-color: var(--autoflow-scheduler-primary-color) !important;
}

.step {
  cursor: not-allowed;
}

.step.clickable {
  cursor: pointer;
}
</style>
